import { getCountryNames } from '@luxuryescapes/lib-countries';

import { BEDBANK_PROPERTY_STATUSES_ENUM } from './bedbank';

export const statusOptions = BEDBANK_PROPERTY_STATUSES_ENUM.map((status) => ({
  label: status,
  value: status,
}));

export const promotionsOptions = [
  {
    label: 'Yes',
    value: 'true',
  },
  {
    label: 'No',
    value: 'false',
  },
];

export const countriesOptions = getCountryNames().map((country) => ({
  label: country,
  value: country,
}));

export const ratingOperatoins = [
  {
    value: '',
    label: 'Op',
  },
  {
    value: 'gt',
    label: '>',
  },
  {
    value: 'lt',
    label: '<',
  },
  {
    value: 'eq',
    label: '=',
  },
  {
    value: 'lte',
    label: '<=',
  },
  {
    value: 'gte',
    label: '>=',
  },
];

export const ratingValues = [
  {
    value: '',
    label: 'Value',
  },
  {
    value: '3',
    label: '3',
  },
  {
    value: '3.5',
    label: '3.5',
  },
  {
    value: '4',
    label: '4',
  },
  {
    value: '4.5',
    label: '4.5',
  },
  {
    value: '5',
    label: '5',
  },
];

export const googleRatingCountOptions = [
  {
    value: '',
    label: 'Count',
  },
  {
    value: '100-500',
    label: '100-500',
  },
  {
    value: '500-1000',
    label: '500-1000',
  },
  {
    value: '1000-plus',
    label: '1000+',
  },
];

export const paymentMethodOptions = [
  {
    value: '',
    label: 'Payment Method',
  },
  {
    value: 'leCollect',
    label: 'Pre-Paid',
  },
  {
    value: 'propertyCollect',
    label: 'Post Paid',
  },
];
